import { Spacer, Text, VStack } from '@ritualco/jutsu'
// TODO: enable auth
// import { useAuth } from 'auth'
import { ReactComponent as HelpIcon } from 'assets/Icons/Help.svg'
import { Link } from 'lib/router'
import { useContent } from 'lib/content/react'
import { AppBar, AppBarDivider } from './AppBar'
import { ProfileMenu } from './ProfileMenu'
import { useAuth } from 'auth'
import { useStore } from 'state/store'

interface HeaderProps {
  workspaceId: string
  name: string
  email: string
}

export const Header = ({ name, email, workspaceId }: HeaderProps) => {
  const { formatMessage } = useContent()
  const { createLogoutUrl } = useAuth()
  const deleteOrganization = useStore(state => state.deleteOrganization)
  const deleteRequestedWorkspaceId = useStore(
    state => state.deleteRequestedWorkspaceId
  )

  const onClickSignOut = () => {
    // After KeyCloak logs the user out, change redirectUri to the home page
    window.location.href = createLogoutUrl({
      redirectUri: `${window.location.protocol}//${window.location.host}`,
    })
    // Clean up
    deleteOrganization()
    deleteRequestedWorkspaceId()
  }
  const menuItems = [
    {
      label: formatMessage({ id: 'pmportal.settings.profile.title' }),
      href: `/workspaces/${workspaceId}/settings/profile`,
    },
  ]

  return (
    <AppBar>
      <Spacer />
      <Link to={`/workspaces/${workspaceId}/settings/help`}>
        <VStack spacing={1}>
          <HelpIcon />
          <Text fontSize="xs" fontWeight="medium" color="grayscale.secondary">
            {formatMessage({ id: 'pmportal.global.actionHelp' })}
          </Text>
        </VStack>
      </Link>
      <AppBarDivider />
      <ProfileMenu
        email={email}
        name={name}
        items={menuItems}
        onSignOut={onClickSignOut}
      />
    </AppBar>
  )
}
